import { ConstantVariables } from "../../Helpers/ConstantVariables";
import { ModalHelper } from "../../Helpers/ModalHelper";
import { AddOrUpdateWebScraperPortalPopupManager } from "../../Managers/WebScraper/AddOrUpdateWebScraperPortalPopupManager";

export class WebScraperPortalConfiguratorContainer {

    constructor(private containerElement: JQuery) { }

    private webScraperPortalsContainer : JQuery<HTMLElement>;
    
    private addOrUpdateWebScraperPortalModalHelper : ModalHelper;
    private addOrUpdateWebScraperPortalManager : AddOrUpdateWebScraperPortalPopupManager;

    public initialize() {
        var self = this;

        self.webScraperPortalsContainer = self.containerElement.find('#web-scraper-portals-container');

        self.addOrUpdateWebScraperPortalModalHelper = new ModalHelper();
        self.addOrUpdateWebScraperPortalModalHelper.createModal("add-or-update-web-scraper-portal-popup", true);

        var addButton = self.containerElement.find('#add-button');
        
        addButton.off('click').on('click', () => {
            self.addOrUpdateWebScraperPortalModalHelper.load(`?handler=AddOrUpdateWebScraperPortal`, undefined, () => {
                if(self.addOrUpdateWebScraperPortalManager == undefined) {
                    self.addOrUpdateWebScraperPortalManager = new AddOrUpdateWebScraperPortalPopupManager(self.addOrUpdateWebScraperPortalModalHelper.getModalContainer());
                }

                self.addOrUpdateWebScraperPortalManager.initialize();
            }, 
            undefined);
        });

        
        (<any>window).initializeAddOrUpdateWebScraperPortal = () => {
            if(self.addOrUpdateWebScraperPortalModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.loadWebScrapePortals();
            }
            else {
                self.addOrUpdateWebScraperPortalManager.initialize();
            }
        }


        self.bindWebScraperPortals();
    }

    private loadWebScrapePortals() {
        var self = this;
        self.webScraperPortalsContainer.html(ConstantVariables.SpinnerHtml).load('?handler=WebScraperPortals', () => {
            self.bindWebScraperPortals();
        });
    }

    private bindWebScraperPortals() {
        var self = this;

        self.webScraperPortalsContainer.find('.card').each((index, element) => {
            var webScraperCard = $(element);
            var portalId = webScraperCard.data('portal-id');

            webScraperCard.find('a[data-action="update-portal"]').off('click').on('click', () => {
                self.addOrUpdateWebScraperPortalModalHelper.load(`?id=${portalId}&handler=AddOrUpdateWebScraperPortal`, undefined, () => {
                    if(self.addOrUpdateWebScraperPortalManager == undefined) {
                        self.addOrUpdateWebScraperPortalManager = new AddOrUpdateWebScraperPortalPopupManager(self.addOrUpdateWebScraperPortalModalHelper.getModalContainer());
                    }

                    self.addOrUpdateWebScraperPortalManager.initialize();
                }, 
                undefined);
            })
        })
    }

}